import { render, staticRenderFns } from "./FormCourse.vue?vue&type=template&id=4b950dbe&scoped=true&"
import script from "./FormCourse.vue?vue&type=script&lang=js&"
export * from "./FormCourse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b950dbe",
  null
  
)

export default component.exports